module.exports = __webpack_public_path__ + "static/200414_more_on_transformers.6badfe90.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teaching_slides/200414_more_on_transformers.pdf
// module id = 346
// module chunks = 22885490386278